// extracted by mini-css-extract-plugin
export default {"subnav":"SubNavigation_subnav__i953s","rightbutton":"SubNavigation_rightbutton__nC9xb","selectBox":"SubNavigation_selectBox__qd0PQ"};